import Route from '@ember/routing/route'

export default class RexStandardsPerformanceRoute extends Route {
  queryParams = {
    sort: {
      replace: true,
    },
    pageNumber: {
      replace: true,
    },
    perPage: {
      replace: true,
    },
  }
}
